import React = require('react');
import ReactDOM = require('react-dom');

import { IReactDomConfig, AppLauncher } from 'pintra-fx';
import { Configurator } from './components/Configurator';
import { polyfill } from 'es6-promise';

const reactDomConfig: IReactDomConfig = AppLauncher.getReactDomConfig();

// Polyfill Promises
polyfill();

/**
 * Bootstrap the app
 */
ReactDOM.render(
  <Configurator env={reactDomConfig.env} />,
  document.getElementById(reactDomConfig.rootId)
);
